import { TypographyOptions } from './types.js'

export const typography: TypographyOptions = {
  title: 'Wordpress Kubrick',
  baseFontSize: '16px',
  baseLineHeight: 1.4,
  headerFontFamily: ['Lucida Grande', 'Verdana', 'Arial', 'Sans-Serif'],
  bodyFontFamily: ['Lucida Grande', 'Verdana', 'Arial', 'Sans-Serif'],
  headerWeight: 'bold',
  bodyWeight: 'normal',
  boldWeight: 'bold',
  overrideStyles: ({ rhythm }) => ({
    h2: {
      marginTop: rhythm(2),
    },
    h3: {
      marginTop: rhythm(2),
    },
    p: {
      marginBottom: '1em',
      marginTop: '1em',
    },
    a: {
      textDecoration: 'none',
    },
    'a:hover': {
      textDecoration: 'underline',
    },
    blockquote: {
      marginTop: rhythm(1),
      marginRight: rhythm(2),
      marginBottom: 0,
      marginLeft: rhythm(5 / 8),
      paddingLeft: rhythm(1.25),
      borderLeft: `${rhythm(1 / 3)} solid hsla(0,0%,0%,0.13)`,
    },
  }),
}
